let dicts = {
    // 个人险状态 个人险 "订单状态(0-待支付，1-待生效，3-保障中，4-已过期，5-投保失败，6-已退保,8-已失效)")
  recommendStatus: [
    { name: "待支付", value: 0 },
    { name: "待生效", value: 1 },
    // { name: "已生效", value: 2 },
    { name: "保障中", value: 3 },
    { name: "已过期", value: 4 },
    { name: "投保失败", value: 5 },
    { name: "已退保", value: 6 },
    // { name: "出单失败", value: 7 },
    { name: "已失效", value: 8 },
  ],

  // 企业险状态 企业险 "订单状态(1-待生效, 2-保障中, 4-待支付, 5-投保失败, 8-已退保,9-已失效,10-已过期)")
  orderStatus: [
    { name: "待生效", value: 1 },
    { name: "保障中", value: 2 },
    { name: "待支付", value: 4 },
    { name: "投保失败", value: 5 },
    { name: "已退保", value: 8 },
    { name: "已失效", value: 9 },
    { name: "已过期", value: 10 },
  ],

  // 定制产品状态
  customizeStatus: [
    { name: '预约中', value: 0 },
    { name: '预约成功', value: 1 },
    { name: '关闭', value: 2 },
    { name: '询价中', value: 3 },
    { name: '已报价', value: 4 },
    { name: '待付款', value: 5 },
    { name: '已付款', value: 6 },
    { name: '保障中', value: 7 },
    { name: '已结束', value: 8 },
    { name: '已失效', value: 9 }
  ]
}

/**
 * 根据字典值获取对应名称
 * @param {*} dict
 * @param {*} value
 * example: getDictNameByValue('status', 1)
 */
function getDictNameByValue (dict, value) {
  if (!dicts[dict]) {
    console.error('找不到字典' + dict)
    return
  }
  return (
    dicts[dict].find(
      item => (item.value || '').toString() === (value || '').toString()
    ) || {}
  ).name
}

// function dictFormatter(row, column, cellValue, index) {
//   return getDictNameByValue(column.property, cellValue)
// }

export { getDictNameByValue }



// WEBPACK FOOTER //
// ./src/config/dict.js